import * as React from 'react'
import cx from 'classnames'
import styles from './NoTasks.sass'

export default function NoTasks() {
  return (
    <div className={cx(styles.root)}>
      <p className={styles.description}>
        You've got no tasks to complete for this milestone.
      </p>
    </div>
  )
}
